import { UiState } from 'instantsearch.js/es/types';
import { InstantSearchNextRouting } from 'react-instantsearch-nextjs';
import generateRouter from './router';
import stateMapping from './stateMapping';
import { BaseRouteState, RoutingConfig } from './types';

export default function generateRouting<U extends string>(
    config: RoutingConfig<U>
): InstantSearchNextRouting<UiState, BaseRouteState> | undefined {
    return {
        stateMapping: stateMapping<U>(config),
        router: generateRouter<U>(config),
    };
}
